export const lsSetItem = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

export const lsGetItem = (key: string) => {
  return window.localStorage.getItem(key);
};

export const lsRmItem = (key: string) => {
  window.localStorage.removeItem(key);
};

export const tokenUtility = () => {

  const generateSecretKey = () => {
    const key1 = getRandomNumber();
    const key2 = getRandomNumber();
    const key3 = getRandomNumber();
    lsSetItem("fuse", String(key1) + key2 + key3);
    return String(key1) + key2 + key3;
  };

  const getRandomNumber = (max = 10) => {
    let a;
    do {
      a = Math.floor(Math.random() * max);
    } while (a === 0);
    return a;
  };
  
  const decrypt = (value: string, key: number) => {
    const a = value.split("");
    return JSON.parse(
      a.map((x) => String.fromCharCode(x.charCodeAt(0) - (key as number)))
      .join(""),
    );
  }

  const encrypt = (value: string | object, key: number) =>
  [...(JSON.stringify(value) as unknown as string[])]
    .map((x) => String.fromCharCode(x.charCodeAt(0) + key))
    .join("");

  const storeToken = (token: string) => {
    const key = generateSecretKey();
    token.split(".").map((item, index) => {
      lsSetItem(`uid${index}`, encrypt(item, +key.split("")[index]));
    });
  };

  const isTokenExpired = (token: string) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c: string) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    const tokenObj: {exp: number} = JSON.parse(jsonPayload);
    return !!(tokenObj.exp && new Date() > new Date(tokenObj.exp * 1000));
  };

  const getStoredToken = () => {
    const key = lsGetItem("fuse");
    const u1 = lsGetItem("uid0");
    const u2 = lsGetItem("uid1");
    const u3 = lsGetItem("uid2");

    if (!u1 || !u2 || !u3 || !key) return;

    const token = `${decrypt(u1, +key[0])}.${decrypt(u2, +key[1])}.${decrypt(u3,+key[2])}`;

    if (isTokenExpired(token)) {
      rmStoredToken();
      return;
    }

    return token;
  };

  const rmStoredToken = () => {
    lsRmItem("fuse");
    lsRmItem("uid0");
    lsRmItem("uid1");
    lsRmItem("uid2");
  };

  return {
    isTokenExpired,
    storeToken,
    getStoredToken,
    rmStoredToken,
  };
};
